import MISSION from './mission';
import NOTIFICATION from './notification';
import REGISTER from './register';
import REGISTER_WITH_MISSION from './registerWithMission';
import PARTNER from './partner';
import WEBINAR from './webinar';

export default {
  MISSION,
  NOTIFICATION,
  PARTNER,
  REGISTER,
  REGISTER_WITH_MISSION,
  WEBINAR
};
